import React, { useState } from 'react';
import {
  Button,
  CircularProgress,
  Menu,
  MenuItem,
  Tooltip
} from '@material-ui/core';
import { GetApp as GetAppIcon } from '@material-ui/icons';

export interface ExportButtonProps {
  isLoading: boolean;
  templateAvailable: boolean;
  hasOption?: boolean;
  onClick: (extension?: 'docx' | 'pdf') => void;
}

const ExportButton: React.FC<ExportButtonProps> = ({
  isLoading,
  templateAvailable,
  hasOption,
  onClick
}) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null);
  return (
    <Tooltip
      title={
        !templateAvailable
          ? 'There are no templates configured for this item. Please contact your administrator'
          : ''
      }
      placement='left'
      arrow
    >
      <div>
        <Button
          color='primary'
          variant='contained'
          className='flex-label'
          disabled={isLoading || !templateAvailable}
          endIcon={
            isLoading ? (
              <CircularProgress color='primary' size={20} />
            ) : (
              <GetAppIcon />
            )
          }
          onClick={e =>
            hasOption ? setMenuAnchorEl(e.currentTarget) : onClick()
          }
        >
          Export
        </Button>
        <Menu
          id='export-menu'
          keepMounted
          open={!!menuAnchorEl}
          anchorEl={menuAnchorEl}
          onClose={() => setMenuAnchorEl(null)}
        >
          <MenuItem
            onClick={() => {
              setMenuAnchorEl(null);
              onClick('docx');
            }}
          >
            Export as DOCX
          </MenuItem>
          <MenuItem
            onClick={() => {
              setMenuAnchorEl(null);
              onClick('pdf');
            }}
          >
            Export as PDF
          </MenuItem>
        </Menu>
      </div>
    </Tooltip>
  );
};
export default ExportButton;
